import clsx from 'clsx'
import type React from 'react'

interface ContainerProps {
  children: React.ReactNode
  center?: boolean
  className?: string
}

export const Container: React.FC<ContainerProps> = ({ children, center = false, className }) => {
  return (
    <div
      className={clsx(
        'container',
        {
          'container--center': center,
        },
        className,
      )}>
      {children}
    </div>
  )
}
